"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableHeaderItem;
var _react = _interopRequireDefault(require("react"));
var _sortable = require("@dnd-kit/sortable");
var _utilities = require("@dnd-kit/utilities");
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _IconTooltip = _interopRequireDefault(require("../IconTooltip"));
const useStyles = (0, _styles.makeStyles)(theme => ({
  dragIcon: {
    marginLeft: props => props.rightAligned ? '0px' : '-20px',
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.neutral[600]
    }
  }
}));
function TableHeaderItem(props) {
  const {
    headCell,
    order,
    orderBy,
    onRequestSort,
    i
  } = props;
  const classes = useStyles({
    rightAligned: headCell.alignment === 'right'
  });
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = (0, _sortable.useSortable)({
    id: headCell.id
  });
  const style = {
    transform: _utilities.CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  return headCell.alignment === 'right' ? /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    ref: setNodeRef,
    id: "table-header-".concat(headCell.id),
    key: headCell.id,
    align: 'right',
    padding: headCell.disablePadding ? 'none' : 'normal',
    sortDirection: orderBy === headCell.id ? order : false,
    style: style,
    className: headCell.className || ''
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse"
  }, headCell.label && /*#__PURE__*/_react.default.createElement(_material.TableSortLabel, {
    sx: {
      flexDirection: 'row-reverse'
    },
    active: orderBy === headCell.id,
    direction: orderBy === headCell.id ? order : 'asc',
    onClick: createSortHandler(headCell.id)
  }, headCell.tooltipTitle && /*#__PURE__*/_react.default.createElement(_IconTooltip.default, {
    title: headCell.tooltipTitle,
    disableRightMargin: true
  }), headCell.label), i > 0 && /*#__PURE__*/_react.default.createElement(_iconsMaterial.DragHandle, Object.assign({
    className: classes.dragIcon
  }, attributes, listeners, {
    sx: {
      verticalAlign: 'middle',
      display: 'inline-flex'
    }
  })))) : /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    ref: setNodeRef,
    id: "table-header-".concat(headCell.id),
    key: headCell.id,
    align: 'left',
    padding: headCell.disablePadding ? 'none' : 'normal',
    sortDirection: orderBy === headCell.id ? order : false,
    style: style,
    className: headCell.className || ''
  }, headCell.label && /*#__PURE__*/_react.default.createElement(_material.TableSortLabel, {
    active: orderBy === headCell.id,
    direction: orderBy === headCell.id ? order : 'asc',
    onClick: createSortHandler(headCell.id)
  }, i > 0 && /*#__PURE__*/_react.default.createElement(_iconsMaterial.DragHandle, Object.assign({
    className: classes.dragIcon
  }, attributes, listeners)), headCell.label, headCell.tooltipTitle && /*#__PURE__*/_react.default.createElement(_IconTooltip.default, {
    title: headCell.tooltipTitle
  })));
}